<style lang="scss" scoped>
.side-wrapper {
    z-index: 10;
    right: 0;

    @media screen and (max-width: 1023.98px) {
        width: 100% !important;
        position: relative !important;
        &.order-list {
            text-align: center;
            display: flex !important;
            > div {
                width: 50%;
            }
        }
    }

    @media screen and (max-width: 575.98px) {
        flex-flow: column;
        &.order-list {
            text-align: left;
            > div {
                width: 100%;
            }
        }
    }
}
</style>

<template>
    <div class="side-wrapper" :style="sideStyle">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "",

    data: () => ({
        sideStyle: { display: 'none' },
        offsetTop: 0,
        offsetBottom: 0
    }),

    mounted() {
        this.parseSideStyle()
        window.addEventListener('resize', () => this.parseSideStyle())
        window.addEventListener('orientationchange', () => this.parseSideStyle())
        window.addEventListener('scroll', () => this.handleWindowScroll())
    },
    methods: {
        parseSideStyle() {
            this.$nextTick().then(() => {
                let side = document.querySelector('.data-fixed-side')
                let suggested_side_width = window.innerWidth - (side.offsetLeft + side.clientWidth) - 24;
                this.sideStyle = { width: `${suggested_side_width}px`, display: 'block', position: 'absolute' }
                this.$nextTick().then(() => {
                    let sideWrapper = document.querySelector('.side-wrapper')
                    this.offsetTop = sideWrapper.offsetTop
                    this.offsetBottom = side.clientHeight + side.offsetTop - sideWrapper.clientHeight
                })
            })
        },
        handleWindowScroll() {
            if (this.$root.isMobile) return
            let top = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
            let offset = 24
            if (top >= this.offsetTop - offset) {
                if (top <= this.offsetBottom) {
                    this.sideStyle.position = 'fixed'
                    this.sideStyle.top = `${offset}px`
                } else {
                    this.sideStyle.position = 'absolute'
                    let topvalue = this.offsetBottom + offset >= 222 ? this.offsetBottom + offset : 222;
                    this.sideStyle.top = `${topvalue}px`
                }
            } else {
                this.sideStyle.position = 'absolute'
                delete this.sideStyle.top
            }
        }
    },
}
</script>